import AdvertiserActions from "../../../../actions/AdvertiserActions";
import GoalActions from '../../../../actions/GoalActions';
import RegionsActions from '../../../../actions/RegionsActions';
import LinksActions from '../../../../actions/LinksActions';
import PublisherBanners from '../../../../actions/PublisherBanners';
import PublisherContainers from '../../../../actions/PublisherContainers';
import PublisherLandings from '../../../../actions/PublisherLandings';
import store from '../../../../stores/redux';
import {
    getRegionIds
} from '../helpers';


const actions = {
    searchGoalEntries(offerId) {
        AdvertiserActions.getGoalEntries({offer_ids: offerId}, () => {
            const goalEntries = store.getState().goalEntries.list;
            const goalIds = _getGoalIds(goalEntries);
            const regionIds = getRegionIds(goalEntries);

            GoalActions.getListGoalActions({goal_ids: goalIds});
            regionIds && RegionsActions.searchRegions({ids: regionIds});
        });
    },

    searchLinks(params) {
        LinksActions.getListLinks(params);
    },

    searchBanners(params) {
        PublisherBanners.getBanners(params);
    },

    searchContainers(params) {
        PublisherContainers.getContainres(params);
    },

    searchLandings(params) {
        PublisherLandings.getLandings(params);
    }
};

const _getGoalIds = (goalEntries) => {
    return goalEntries.map(g => g.goal.id).join(',');
};

export default actions;

